// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"94":"9e2197c31071a734788a","663":"49adce75ffe180d20b2d","679":"8bb0d7a2b08d760a206f"}[chunkId] + ".js";
};